import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { ThemeProvider } from "@mui/material/styles"
import theme from "theme"
import Works from "pages/Works"
import Links from "pages/Links"
import Generators from "pages/Generators"
import Disclaimer from "pages/Disclaimer"
import Privacy from "pages/Privacy"
//import Gallery from "pages/Gallery"

//<Route path="gallery" element={<Gallery/>}/>

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route index element={<Works/>}/>
            <Route path="links" element={<Links/>}/>
            <Route path="generators" element={<Generators/>}/>
            <Route path="disclaimer" element={<Disclaimer/>}/>
            <Route path="privacy" element={<Privacy/>}/>
          </Routes>
        </Router>
      </ThemeProvider>
    </>
  )
}

export default App
